export default __webpack_public_path__ + "45de4ef7020811727af5b168ed7d08fd.woff2";